import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import InsiderTradingFull from './InsiderTradingFull';
import { Helmet } from "react-helmet";

class InsiderTradingWrap extends Component {

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Insider Trading details</title>
          <link rel="canonical" href="https://www.vizfm.com/insider" />
          <meta name="description" content="Symbol or Stock Insider Trading details, Insider transactions, Insider purchase or sale price and quantity" />
        </Helmet>

        <Container fluid className="p-2">
          <Row>
            <Col>
              Insider Trading
              <InsiderTradingFull limit={100} />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default InsiderTradingWrap;
